// CoopNetLogo — emblema de CoopNet inspirado en el símbolo universal del
// cooperativismo: dos pinos dentro de un círculo. Los pinos representan la
// longevidad y la fecundidad del movimiento (y que uno solo no basta: hacen
// falta dos para cooperar), el círculo la unidad y la permanencia, el verde
// la vida y el amarillo-oro el sol. Mismo dibujo que public/favicon.svg.

import React from 'react';

const VERDE = '#1B5E20';
const ORO = '#F9A825';

const pino = (cx) => (
  <g fill={VERDE}>
    <path d={`M${cx} 11 L${cx - 6} 22 L${cx + 6} 22 Z M${cx} 17 L${cx - 8} 30 L${cx + 8} 30 Z M${cx} 24 L${cx - 9.5} 39 L${cx + 9.5} 39 Z`} />
    <rect x={cx - 1.8} y={38.5} width={3.6} height={8} rx={0.6} />
  </g>
);

export default function CoopNetLogo({ size = 40, sx, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="CoopNet" style={{ display: 'block', ...sx }} {...props}>
      <circle cx="32" cy="32" r="31" fill={ORO} />
      <circle cx="32" cy="32" r="27.5" fill="none" stroke={VERDE} strokeWidth="3" />
      {pino(23.5)}
      {pino(40.5)}
      <rect x="14" y="46" width="36" height="2.6" rx="1.3" fill={VERDE} />
    </svg>
  );
}
